module.exports = __webpack_public_path__ + "img/student_20.502f7723.png";